import React from 'react';

export const RoughEdgeFilters = () => (
	<svg width="0" height="0" style={{ position: 'absolute' }}>
		<defs>
			<filter id="fuzz">
				<feTurbulence type="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" />
				<feDisplacementMap in="SourceGraphic" in2="noise" scale="1.5" />
			</filter>
			<filter id="fuzzXL">
				<feTurbulence type="turbulence" baseFrequency="0.015" numOctaves="4" result="noise" />
				<feDisplacementMap in="SourceGraphic" in2="noise" scale="2.5" />
			</filter>
		</defs>
	</svg>
);
